import { createFileRoute } from '@tanstack/react-router';

import { requireOnboardingStage } from '../../features/onboarding/require-onboarding-stage';
import { UploadPanel } from '../../features/onboarding/upload-panel';

export const Route = createFileRoute('/onboarding/upload')({
  beforeLoad: ({ context, location }) =>
    requireOnboardingStage({
      queryClient: context.queryClient,
      location,
      path: '/onboarding/upload',
    }),
  component: UploadPanel,
});
